<template>
  <div>
    <c-header></c-header>
    <c-entry-edit />
    <c-comment-edit />
    <!-- ルートとマッチしたコンポーネントがここへ描画されます -->
    <router-view />
    <c-footer></c-footer>
    <div class="Page-Btn" @click="scrollTop">
      <i class="fas fa-chevron-up Page-Btn-Icon"></i>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from "vue"
import { useStore } from "vuex"

// store取得
const store = useStore();

// action操作はdispatch
const getAllAccounts = () => store.dispatch('getAllAccounts');
const getCircles = () => store.dispatch('getCircles');

// mutation操作はcommit
const setSessionId = (val) => store.commit('setSessionId', val);


// --- created ---
(() => {
  getAllAccounts()
  getCircles()
})();

// --- mounted ---
onMounted(() => {
  setSessionId(document.getElementById('rails_session_id').value);
});

// --- methods --- 
const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
</script>
<style lang="scss">
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
